<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroVideo]="heroVideo"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">

  <!-- Page Title Section -->
  <div class="page-title-section">
    <h2>Assurance Mutuelle Santé Entreprise</h2>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <p>
      Si vous êtes à la recherche de ce type d'assurance <span class="text-purple">Mutuelle Santé Entreprise</span>, merci de prendre contact avec nous car il existe beaucoup trop de déclinaisons selon votre situation personnelle.
    </p>
  </div>

  <!-- Partner Info -->
  <div class="main-content">
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <span class="text-purple">GENERALI, APRIL, SWISSLIFE, MALAKOFF HUMANIS, ALPTIS, POP SANTÉ, HENNER, AVENIR MUTUELLE, UCR, PRAECONIS, ENTORIA...</span>
    </p>
  </div>

  <!-- Contact Button -->
  <div class="devis-button-wrapper">
    <button class="btn-devis" (click)="navigateToContact()">
      Contactez-nous
    </button>
  </div>

</app-page-layout>
